import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { SecurityHelper } from './pages/common/securityHelper';
import { SecurityService } from './pages/security/service/security.service';
import { RouteService } from './services/route.service';
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'app';
  update: boolean = false;
  storageRemaining!: string;
  deferredPrompt: any;
  constructor(private router: Router, private securityService: SecurityService,
    public nav: NavigationItem, private routeService: RouteService, private swUpdate: SwUpdate) {

    this.router.events.subscribe((evt) => {

      if (evt instanceof NavigationEnd) {
        if (this.router.url != '/') {

          // user must be logged-in
          if (SecurityHelper.GetLoggedInUserDto()) {
            let pageName = this.nav.getPageNameByURL(this.router.url);
            // this.createDailyLogs(pageName, Helper.Constants.DailyLogs.Actions.PAGE_VIEW, Helper.Constants.DailyLogs.Results.SUCCESSFUL, "The user navigated to the page.");
          }

        }
      }
    });

  }
  changeMenuFixedLayout(flag: any) {
    setTimeout(() => {
      if (flag) {
        document.querySelector('.pcoded-navbar')!.classList.remove('menupos-static');
        document.querySelector('.pcoded-navbar')!.classList.add('menupos-fixed');
        //if (this.nextConfig.layout === 'vertical') {
        (document.querySelector('#nav-ps-next') as HTMLElement).style.maxHeight = 'calc(100vh - 60px)'; // calc(100vh - 70px) amit
        //(document.querySelector('#nav-ps-next') as HTMLElement).style.maxHeight = 'calc(100vh - 70px) amit'; // calc(100vh - 70px) amit
        //}
        window.addEventListener('scroll', this.scroll, true);
        window.scrollTo(0, 0);
      } else {
        document.querySelector('.pcoded-navbar')!.classList.add('menupos-static');
        document.querySelector('.pcoded-navbar')!.classList.remove('menupos-fixed');
        //if (this.nextConfig.layout === 'vertical') {
        (document.querySelector('#nav-ps-next') as HTMLElement).style.maxHeight = 'calc(100%)'; // calc(100% - 70px) amit
        // (document.querySelector('#nav-ps-next') as HTMLElement).style.maxHeight = 'calc(100% - 70px) amit'; // calc(100% - 70px) amit
        //}
        //if (this.nextConfig.layout === 'vertical') {
        window.removeEventListener('scroll', this.scroll, true);
        //}

      }
    }, 100);
  }

  scroll = (): void => {
    // if (this.headerFixedLayout === false) {
    (document.querySelector('#nav-ps-next') as HTMLElement).style.maxHeight = 'calc(100vh)';
    const el = document.querySelector('.pcoded-navbar.menupos-fixed') as HTMLElement;
    const scrollPosition = window.pageYOffset;
    if (scrollPosition > 60) {
      el.style.position = 'fixed';
      el.style.transition = 'none';
      el.style.marginTop = '0';
    } else {
      el.style.position = 'absolute';
      el.style.marginTop = '60px';
    }
    //  } else if (document.querySelector('.pcoded-navbar').hasAttribute('style')) {
    document.querySelector('.pcoded-navbar.menupos-fixed')!.removeAttribute('style');
    //  }
  }

  previousUrl: any = null;
  currentUrl: any = null;
  ngOnInit() {

    // Check for updates on this specific path in cases where users do not visit the splash screen first.
    if (this.swUpdate.isEnabled && window.location.hash.includes('reset-password')) {

      // Trigger an explicit update check
      console.log('Checking for new version...');
      this.swUpdate.checkForUpdate();

      // When a new version is ready, activates the update and reloads the app
      this.swUpdate.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(async () => {
          console.log('A new version is available. Activating...');
          await this.swUpdate.activateUpdate();
          location.reload();
        });
    }

    let env = environment.production;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      this.routeService.setPreviousUrl(this.previousUrl);
    });
    this.testbrowserStorage();
  }

  formatBytes(bytes: any, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }

  async testbrowserStorage() {
    if (navigator.storage && navigator.storage.estimate) {
      const quota: any = await navigator.storage.estimate();
      // quota.usage -> Number of bytes used.
      // quota.quota -> Maximum number of bytes available.
      const percentageUsed = (quota.usage / quota.quota) * 100;
      console.log(`You've used ${percentageUsed}% of the available storage.`);
      this.storageRemaining = this.formatBytes(quota.quota - quota.usage);
      console.log(`You can write up to ${this.storageRemaining} more bytes.`);
    }
  }

  // This will clear localStorage when closing the browser / on page refresh
  @HostListener("window:beforeunload", ["$event"])
  clearLocalStorage(event: any) {
    //localStorage.clear();
    localStorage.removeItem(SecurityHelper.WebStorage.Keys.AUTHENTICATED_WS);
    let userName = SecurityHelper.GetLoggedInUserData().username;
    this.securityService.saveIsAuthenticated(userName, false);
  }
}
